import React from 'react';
import { useIntl } from 'react-intl';

import LocalizedNumber from 'common/components/LocalizedNumber';

export const RenderPrice = ({
  value,
  currency,
  primaryLanguage,
  isVatExcluded = true,
  isPricePerWeek = false,
}: {
  value: string | undefined;
  currency: Currency;
  primaryLanguage: string;
  isPricePerWeek?: boolean;
  isVatExcluded?: boolean;
}): React.ReactNode => {
  const intl = useIntl();
  const isNotANumber = typeof value === 'string' && isNaN(parseFloat(value));

  if (value === '-' || isNotANumber || !value) {
    return <span>-</span>;
  }

  const numericValue = parseFloat(value);
  const isInt = Number.isInteger(numericValue);

  const price = (
    <LocalizedNumber
      value={numericValue}
      locales={primaryLanguage}
      options={{
        style: 'currency',
        currency,
        currencyDisplay: 'symbol',
        maximumFractionDigits: isInt ? 0 : 2,
      }}
    />
  );

  const pricePerWeekInfo = isPricePerWeek
    ? intl.formatMessage(
        { id: 'self-serve-sign-up.cost-per-week' },
        {
          cost: price,
        },
      )
    : price;

  return (
    <span>
      {isVatExcluded
        ? intl.formatMessage(
            { id: 'self-serve-sign-up.price-excluding-vat' },
            {
              price: pricePerWeekInfo,
            },
          )
        : pricePerWeekInfo}
    </span>
  );
};
